import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { Test2Page } from './components/Test2Page';
import { OnboardingPage } from './components/OnboardingPage';
import { DirectoryPage } from './components/DirectoryPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-5">
      <Routes data-id="element-6">
        <Route path="/" element={<DirectoryPage data-id="element-8" />} data-id="element-7" />
        <Route path="/assessment" element={<App data-id="element-10" />} data-id="element-9" />
        <Route path="/test" element={<App data-id="element-12" />} data-id="element-11" />
        <Route path="/test2" element={<Test2Page data-id="element-14" />} data-id="element-13" />
        <Route path="/onboarding" element={<OnboardingPage data-id="element-16" />} data-id="element-15" />
      </Routes>
    </BrowserRouter>;
}